// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".m-orm-view-table{border:1px solid rgba(0,0,0,.12)}.m-orm-view-table__row:nth-child(2n-1){background-color:#f0f6fc}.m-orm-view-table__row-data{padding:0 30px!important}", ""]);
// Exports
module.exports = exports;
